import type { Urls } from "@selector/shared";

export function routeWithBasename(route: string, urls: Urls): string {
  const baseUrl = location.origin + (urls.basePath === "/" ? "" : urls.basePath.slice(0, -1));
  return baseUrl + route;
}
